"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClerkProvider = void 0;
var ClerkProvider_1 = require("./ClerkProvider");
Object.defineProperty(exports, "ClerkProvider", { enumerable: true, get: function () { return ClerkProvider_1.ClerkProvider; } });
//# sourceMappingURL=index.js.map